module.exports = __webpack_public_path__ + "img/qr-slide-3.b0564bf8.png";